var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39052 4.39052C4.91122 3.86983 5.75544 3.86983 6.27614 4.39052L12 10.1144L17.7239 4.39052C18.2446 3.86983 19.0888 3.86983 19.6095 4.39052C20.1302 4.91122 20.1302 5.75544 19.6095 6.27614L13.8856 12L19.6095 17.7239C20.1302 18.2446 20.1302 19.0888 19.6095 19.6095C19.0888 20.1302 18.2446 20.1302 17.7239 19.6095L12 13.8856L6.27614 19.6095C5.75544 20.1302 4.91122 20.1302 4.39052 19.6095C3.86983 19.0888 3.86983 18.2446 4.39052 17.7239L10.1144 12L4.39052 6.27614C3.86983 5.75544 3.86983 4.91122 4.39052 4.39052Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon5);
export default __webpack_public_path__ + "static/media/close-icon-5.362af8ff6b911d80c6bbfaa896277793.svg";
export { ForwardRef as ReactComponent };